import React, { useState } from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const MAP_EMBED_URL = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2777.6256247656985!2d10.950796376518174!3d45.73863487107936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47820a22a35606d9%3A0xe54d2448de05a497!2sViale%20al%20Parco%2C%203%2C%2038063%20Sabbionara%20TN%2C%20Italy!5e0!3m2!1sit!2sit!4v1700000000000!5m2!1sit!2sit";

export default function Contatti() {
  const [showMap, setShowMap] = useState(false);
  return (
    <div className="w-full pt-40 md:pt-48 pb-32 px-6 lg:px-12 bg-white min-h-screen flex flex-col md:flex-row gap-20 max-w-screen-2xl mx-auto">
      <motion.div 
        initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}
        className="w-full md:w-5/12 flex flex-col justify-center"
      >
        <h1 className="text-5xl md:text-6xl lg:text-[5.5rem] font-bold tracking-tighter mb-10 uppercase leading-[1.1] whitespace-nowrap">
          Contatti
        </h1>
        <p className="text-2xl md:text-3xl font-light text-gray-600 mb-16 max-w-xl leading-relaxed">
          Hai bisogno di consigli nella scelta del serramento giusto per te? Mandaci il tuo progetto.
        </p>

        <div className="space-y-8 font-light text-lg">
          <div>
            <h4 className="font-bold uppercase tracking-widest text-sm mb-2 text-gray-400">Sede Principale</h4>
            <p>Viale al Parco 3, Avio,<br/>frazione Sabbionara, Italia</p>
          </div>
          <div>
            <h4 className="font-bold uppercase tracking-widest text-sm mb-2 text-gray-400">Recapiti</h4>
            <p><a href="mailto:info@izosmart.com" data-testid="email-info" className="hover:underline">info@izosmart.com</a><br/>Sede Avio: <a href="tel:+393387010065" data-testid="phone-sede-avio" className="hover:underline">+39 338 7010065</a><br/>Commerciale: <a href="tel:+393509500280" data-testid="phone-commerciale" className="hover:underline">+39 350 950 0280</a></p>
          </div>
        </div>
      </motion.div>

      <motion.div 
        initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }}
        className="w-full md:w-7/12 h-80 md:h-auto md:min-h-[600px] bg-gray-200 border border-gray-300 relative overflow-hidden"
      >
        {showMap ? (
          <iframe 
            src={MAP_EMBED_URL}
            width="100%" 
            height="100%" 
            style={{ border: 0, position: "absolute", inset: 0 }} 
            allowFullScreen="" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Mappa Sede Izosmart"
            data-testid="contatti-map"
          ></iframe>
        ) : (
          <div data-testid="contatti-map-placeholder" className="absolute inset-0 flex flex-col items-center justify-center text-center p-8 gap-6 bg-gray-100">
            <MapPin size={40} className="text-[#7dba00]" />
            <p className="text-lg font-light text-gray-700 max-w-md">
              La mappa è fornita da Google Maps. Caricandola, il tuo browser si collega ai server di Google, che possono impostare propri cookie.
            </p>
            <button
              type="button"
              onClick={() => setShowMap(true)}
              data-testid="contatti-map-load-btn"
              className="bg-black text-white px-10 py-4 uppercase text-sm font-bold tracking-[0.2em] hover:bg-[#7dba00] transition-colors"
            >
              Mostra la mappa
            </button>
            <a href="https://www.google.com/maps/search/?api=1&query=Viale+al+Parco+3,+38063+Avio+TN" target="_blank" rel="noopener noreferrer" data-testid="contatti-map-external-link" className="text-sm underline text-gray-600 hover:text-[#7dba00]">
              Apri in Google Maps
            </a>
          </div>
        )}
      </motion.div>
    </div>
  );
}
